export enum LeadManagementTrigger {
    ENGAGE = 'engage',
    REVEAL = 'reveal'
};

export enum TrackingStepName {
    START = 'start',
    COMPLETE = 'complete',
    OUTCOME = 'outcome',
};

export enum TrackingProductVendor {
    KDG = 'cable',
    UME = 'cable (unity)',
    DSL = 'dsl',
    FIBER = 'fiber',
};

export enum TrackingFootprint {
    KDG = 'kabel deutschland',
    UME = 'unitymedia'
}

export enum TrackingType {
    Contact = 'contact',
};

export enum TrackingPageType {
    Availability = 'availability',
    Content = 'content'
};
